import { createContext } from "react";
import { MarkerData } from "./entity/MarkerData";

interface MapContextType {
  selectedMarker: MarkerData | null;
  setSelectedMarker: (marker: MarkerData | null) => void;
}

export const MapContext = createContext<MapContextType>({
  selectedMarker: null,
  setSelectedMarker: () => {},
});
